import React from "react";
import { Typography, ListItem, ListItemAvatar, Avatar, ListItemText, Box, Grid2, CardMedia } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { CustomIconButton } from "../../utils/IconButton";
import MainDialogBox from "../Dialog/MainDialogBox";
import { BulletList } from "../../utils/BulletList";
import { PriceSection } from "./PurchasedCourseCard";
import { useDialog } from "../../hook/useDialog";
import { MovingText } from "../../utils/MovingText";

const BookedEvent = ({ item }) => {
  const { open, handleClickOpen, handleClose } = useDialog();
  const { event_images, event_name, start_date, end_date, start_time, end_time, event_description, event_fees, event_venue } = item;

  return (
    <>
      <ListItem sx={{ width: "100%", display: "flex", alignItems: "center" }}>
        <ListItemAvatar>
          <Avatar alt="event_thumbnail" src={`https://stage.myskool.club/events/assets/admin/img/event-gallery/${event_images[0]}`} sx={{ width: "50px", height: "50px" }} />
        </ListItemAvatar>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flex: 1, ml: 1 }}>
          <ListItemText
            primary={
              <MovingText text={event_name} variant={"h5"}/>
            }
            secondary={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <AccessTimeIcon sx={{ color: "secondary.light", fontSize: 15 }} />
                <Typography variant="h6" color="secondary.light" >
                  {start_time}-{end_time}
                </Typography>
              </Box>

            }
          />

          <CustomIconButton icon={<ArrowForwardIosIcon sx={{ color: "blue.main", fontSize: 15 }} />} onClick={handleClickOpen} />

        </Box>
      </ListItem>

      <MainDialogBox open={open} handleClose={handleClose}>
        <Grid2 container spacing={"35px"} >
          <Grid2 children size={{ xs: 12, lg: 5 }}>
            <CardMedia
              sx={{
                width: "100%",
                borderRadius: "15px",
                height: { xs: "300px", lg: "100%" }
              }}
              image={`https://stage.myskool.club/events/assets/admin/img/event-gallery/${event_images[0]}`}

            />
          </Grid2>
          <Grid2 children size={{ xs: 12, lg: 7 }}
            sx={{
              maxHeight: { xs: "auto", lg: "60vh" },
              overflowY: { xs: "auto", lg: "scroll" },
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >

            <Typography variant='h2'>{event_name}</Typography>
            <PriceSection start_date={` ${start_date} ${start_time}`} end_date={`${end_date} ${end_time}`} price={event_fees} apartment={event_venue} isdicount={false} />
            {/* <Typography variant='h6' color='secondary.light' my={2}>
                  {event_description?.description}
                </Typography> */}
            {event_description && (
              <Box my={2}>
                <BulletList title={"Description"} items={event_description} />
              </Box>
            )}
          </Grid2>
        </Grid2>
      </MainDialogBox>
    </>


  )
}

export default BookedEvent